export const isRestrictedImpersonatee = state => state.isRestrictedImpersonatee.canEditUser;